"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var _default = (0, _styles.makeStyles)(function () {
  return {
    root: {
      '& ul': {
        display: 'flex !important',
        padding: 0,
        margin: 0,
        transition: 'transform 500ms ease-in'
      },
      '& [role="listbox"]': {
        overflow: 'hidden',
        width: '100%'
      }
    }
  };
});

exports["default"] = _default;